function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "dashboard_menu");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M178.53,0H29C15,0,0,7.63,0,29V129.25c0,21.38,15,29,29,29H84.35v18.48H75.16a4.47,4.47,0,0,0,0,8.93h58.91a4.47,4.47,0,1,0,0-8.93H123.18V158.26h55.35c21.38,0,29-15,29-29V29C207.54,7.63,192.54,0,178.53,0ZM114.26,176.74h-21V158.26h21Zm84.35-47.49c0,6-2,20.09-20.08,20.09H29c-6,0-20.08-2-20.08-20.09v-6.38H198.61Zm0-15.26H8.93V29.19C8.93,11.07,23,9.1,29,9.1H178.53c6,0,20.08,2,20.08,20.09Z",
  fill: "#00a09b"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M106.36,60.33V25.59a2.52,2.52,0,0,0-5,0V60.33a11.26,11.26,0,0,0,0,22v15.3a2.52,2.52,0,1,0,5,0V82.28a11.26,11.26,0,0,0,0-22Zm-2.51,17.2a6.22,6.22,0,1,1,6.22-6.22A6.23,6.23,0,0,1,103.85,77.53Z",
  fill: "#00a09b"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M80.11,42.35V25.59a2.52,2.52,0,0,0-5,0V42.35a11.26,11.26,0,0,0,0,21.95V97.58a2.52,2.52,0,1,0,5,0V64.28a11.25,11.25,0,0,0,0-21.93Zm-2.52,17.2a6.23,6.23,0,1,1,6.22-6.22A6.23,6.23,0,0,1,77.59,59.55Z",
  fill: "#00a09b"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M132.46,42.35V25.59a2.52,2.52,0,0,0-5,0V42.35a11.26,11.26,0,0,0,0,21.95V97.6a2.52,2.52,0,0,0,5,0V64.28a11.25,11.25,0,0,0,0-21.93ZM130,59.55a6.23,6.23,0,1,1,6.22-6.22A6.23,6.23,0,0,1,130,59.55Z",
  fill: "#00a09b"
});

var SvgDashboardMenu = function SvgDashboardMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 207.54,
    height: 185.67,
    viewBox: "0 0 207.54 185.67",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDashboardMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard_menu.1921bbf9.svg";
export { ForwardRef as ReactComponent };